import styled from "@emotion/styled";
import {EventPresenter, eventPresenterClasses} from "@mediaspace/event-platform/event-presenter";
import {Box} from "@mediaspace/shared/styled";

export const StyledPresenterContainer = styled(Box)(({ theme }) => ({
    "& > a": {
        textDecoration: "none",
        display: "block",
    },
    height: 48
}));

export const StyledPresenter = styled(EventPresenter)(({ theme }) => ({
    "& .kms-ds-event-presenter-thumbnail, & .kms-ds-event-presenter-thumbnail-initials": {
        borderRadius: theme.kaltura.shape.roundness2,
        width: 48,
        height: 48,
    },

    [`.${eventPresenterClasses.details}`]: {
        marginTop: "auto",
        marginBottom: "auto",
    },
}));
